import React from 'react';
import { withOptionalId } from '@lib/withOptionalId';

type GridLayoutProps = React.HTMLAttributes<HTMLDivElement> & {
  /** Value for grid variant, e.g. "4" → grid-4, "with-aside" → grid-with-aside (grid-2 to grid-6) */
  gridColumns: string;
  /** Optional id for the grid container */
  gridId?: string;
  /** Optional extra class names, merged with grid-{gridColumns} */
  gridClassName?: string;
};

const GridLayout = ({
  children,
  gridColumns,
  gridId,
  gridClassName,
  className,
  ...rest
}: GridLayoutProps) => {
  const mergedClassName = [`grid-${gridColumns}`, gridClassName, className]
    .filter(Boolean)
    .join(' ');
  return (
    <div {...withOptionalId(gridId)} className={mergedClassName} {...rest}>
      {children}
    </div>
  );
};

export default GridLayout;
